/* ==============================================================
   AMIGO PROVISIONS — Father's Day cap rotator
   --------------------------------------------------------------
   Crossfades the cap images inside [data-fday-rotator] on an
   interval. Pairs with .fday__cap / .is-active in
   assets/amigo-section-fathers-day.css. Skips auto-rotation when
   the visitor prefers reduced motion (first cap stays shown).
   ============================================================== */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;

  document.querySelectorAll('[data-fday-rotator]').forEach((rotator) => {
    if (rotator.dataset.fdayInit === 'true') return;
    rotator.dataset.fdayInit = 'true';

    const caps = rotator.querySelectorAll('.fday__cap');
    if (caps.length < 2) return;

    const interval = parseInt(rotator.dataset.interval, 10) || 2600;
    let current = 0;

    setInterval(() => {
      caps[current].classList.remove('is-active');
      current = (current + 1) % caps.length;
      caps[current].classList.add('is-active');
    }, interval);
  });
})();
